import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import userReducer from "./UserReducer";

const MainReducer = combineReducers({
    AuthReducer:AuthReducer,
    user:userReducer
});

export default MainReducer;